export const testimonials = [
  {
    name: "Sophie L.",
    country: "France",
    flag: "🇫🇷",
    specialty: "dental" as const,
    quote: "Une prise en charge exceptionnelle du début à la fin. Mon coordinateur parlait parfaitement français et chaque détail était anticipé.",
    rating: 5,
  },
  {
    name: "James W.",
    country: "United Kingdom",
    flag: "🇬🇧",
    specialty: "hair" as const,
    quote: "The results exceeded my expectations. The clinic was world-class and the follow-up care has been outstanding.",
    rating: 5,
  },
  {
    name: "Anna M.",
    country: "Germany",
    flag: "🇩🇪",
    specialty: "vision" as const,
    quote: "Perfekte Organisation, von der ersten Beratung bis zur Nachsorge. Ich kann wieder ohne Brille sehen.",
    rating: 5,
  },
  {
    name: "Marco R.",
    country: "Italy",
    flag: "🇮🇹",
    specialty: "aesthetic" as const,
    quote: "Professionalità e discrezione assoluta. Il risultato è naturale, esattamente quello che desideravo.",
    rating: 5,
  },
  {
    name: "Sarah K.",
    country: "United States",
    flag: "🇺🇸",
    specialty: "dental" as const,
    quote: "I was nervous about traveling for dental work, but Aurelian made everything seamless. The savings were incredible for the quality I received.",
    rating: 5,
  },
  {
    name: "Fatima A.",
    country: "UAE",
    flag: "🇦🇪",
    specialty: "aesthetic" as const,
    quote: "خدمة استثنائية واحترافية عالية. كل التفاصيل كانت مرتبة بشكل مثالي من البداية حتى النهاية.",
    rating: 5,
  },
];
